
// Configuration for the BlockStack game
export const GAME_CONFIG = {
  // Game board dimensions
  gameWidth: 320,
  gameHeight: 600,
  
  // Grid properties
  boardWidth: 10,
  boardHeight: 20,
  blockSize: 30,
  
  // Game colors
  backgroundColor: 0x000000,
  gridColor: 0x222222,
  
  // Game speed settings
  initialSpeed: 700, // milliseconds per drop
  speedIncrement: 50, // How much faster it gets after each level
  minSpeed: 100, // Fastest possible drop speed
  
  // Scoring
  pointsPerLine: 100,
  pointsForBlockStack: 400, // Clearing 4 lines at once
  
  // Block colors
  colors: {
    I: 0x00ffff, // Cyan
    O: 0xffff00, // Yellow
    T: 0x800080, // Purple
    S: 0x00ff00, // Green
    Z: 0xff0000, // Red
    J: 0x0000ff, // Blue
    L: 0xff8000  // Orange
  },
  
  // Block shapes (using 4x4 grid representation)
  shapes: {
    I: [
      [0, 0, 0, 0],
      [1, 1, 1, 1],
      [0, 0, 0, 0],
      [0, 0, 0, 0]
    ],
    O: [
      [0, 0, 0, 0],
      [0, 1, 1, 0],
      [0, 1, 1, 0],
      [0, 0, 0, 0]
    ],
    T: [
      [0, 0, 0, 0],
      [0, 1, 0, 0],
      [1, 1, 1, 0],
      [0, 0, 0, 0]
    ],
    S: [
      [0, 0, 0, 0],
      [0, 1, 1, 0],
      [1, 1, 0, 0],
      [0, 0, 0, 0]
    ],
    Z: [
      [0, 0, 0, 0],
      [1, 1, 0, 0],
      [0, 1, 1, 0],
      [0, 0, 0, 0]
    ],
    J: [
      [0, 0, 0, 0],
      [1, 0, 0, 0],
      [1, 1, 1, 0],
      [0, 0, 0, 0]
    ],
    L: [
      [0, 0, 0, 0],
      [0, 0, 1, 0],
      [1, 1, 1, 0],
      [0, 0, 0, 0]
    ]
  }
};
